module.exports = __webpack_public_path__ + "static/media/p1.667c6086.webp";